module.exports = __webpack_public_path__ + "static/media/toggle_closed_btn_icon.ba6af6ce.svg";